import React from 'react';
import { GiFruitBowl, GiPlantSeed, GiEarthAmerica } from 'react-icons/gi';
import { FaLeaf, FaHeartbeat } from 'react-icons/fa';
import { FiTag } from 'react-icons/fi';
import Reveal from '../Reveal/Reveal';
import '../../styles/why.css';

const FEATURES = [
  {
    icon: <GiFruitBowl />,
    title: 'Farm Fresh',
    desc: 'Harvested at peak ripeness and delivered straight from our fields to you.',
    color: '#4f7942',
  },
  {
    icon: <GiPlantSeed />,
    title: 'Naturally Grown',
    desc: 'Grown in living soil using time-honoured natural farming methods.',
    color: '#2f8f6d',
  },
  {
    icon: <GiEarthAmerica />,
    title: 'Eco Friendly',
    desc: 'Sustainable practices that protect biodiversity and the environment.',
    color: '#2f8f9d',
  },
  {
    icon: <FaLeaf />,
    title: 'Chemical Free',
    desc: 'Absolutely no synthetic pesticides, fertilizers or preservatives.',
    color: '#5a8f3c',
  },
  {
    icon: <FiTag />,
    title: 'Affordable',
    desc: 'Fair pricing by selling directly — no middlemen involved.',
    color: '#c9862f',
  },
  {
    icon: <FaHeartbeat />,
    title: 'Healthy Lifestyle',
    desc: 'Wholesome nutrition that supports the well-being of your family.',
    color: '#b7791f',
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="section why">
      <div className="container">
        <Reveal className="section-head">
          <h2 className="section-title">Rooted in trust, grown with care</h2>
        </Reveal>

        <div className="why__grid">
          {FEATURES.map((f, i) => (
            <Reveal
              key={f.title}
              delay={Math.min((i % 3) + 1, 5)}
              className="why-card"
              style={{ '--card-color': f.color }}
            >
              <span className="why-card__icon">{f.icon}</span>
              <h3 className="why-card__title">{f.title}</h3>
              <p>{f.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
